import { filterEmptyAssistantMessages } from "./chat-history";
import { uiMessageGqlToVercel } from "./convert/to-vercel";
import type { GraphQLAgentChat } from "./fragment.types";
import type { AgentUIMessage } from "./types";

export type AgentChatModel = {
  id: string;
  title?: string | null;
  shared: boolean;
  organizationID: string;
  createdByUserID: string;
  activeWorkflowSkills: {
    id: string;
    title: string;
    status: string;
    spec: {
      useWhen: string[];
      avoidWhen: string[];
      steps: string[];
      allowedToolNames: string[];
      outputContract: string;
      failureHandling: string;
    };
  }[];
  createdAt: string;
  updatedAt: string;
  messages: AgentUIMessage[];
};

export function convertAgentChat(chat: GraphQLAgentChat): AgentChatModel {
  return {
    id: chat.id,
    title: chat.title,
    shared: chat.shared,
    organizationID: chat.organizationID,
    createdByUserID: chat.createdByUserID,
    activeWorkflowSkills: chat.activeWorkflowSkills.map((skill) => ({
      id: skill.id,
      title: skill.title,
      status: skill.status,
      spec: {
        useWhen: [...skill.spec.useWhen],
        avoidWhen: [...skill.spec.avoidWhen],
        steps: [...skill.spec.steps],
        allowedToolNames: [...skill.spec.allowedToolNames],
        outputContract: skill.spec.outputContract,
        failureHandling: skill.spec.failureHandling,
      },
    })),
    createdAt: chat.createdAt,
    updatedAt: chat.updatedAt,
    messages: filterEmptyAssistantMessages(
      chat.messages.map(
        (message) => uiMessageGqlToVercel(message) as AgentUIMessage,
      ),
    ),
  };
}
